module.exports = __webpack_public_path__ + "img/index-product-scan-blue.0d1e6057.png";